"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class FuseMaterialColorPickerModule {
}
exports.FuseMaterialColorPickerModule = FuseMaterialColorPickerModule;
